export function formatCents(cents: number): string {
  return (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  })
}

export function formatPercent(ratio: number): string {
  return `${Math.round(ratio * 100)}%`
}

/**
 * Money with cents, for figures a person is asked to confirm rather than scan.
 *
 * `formatCents` rounds to whole dollars, which is right for dashboard tiles but
 * wrong anywhere the exact number matters: a 49-cent balance renders as "$0",
 * so a forfeit dialog would ask someone to acknowledge destroying nothing.
 */
export function formatCentsExact(cents: number): string {
  return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}
